import routes from './routes';
import reducer from './reducer';

export default {
    getRoutes: function(env) {
        return routes(env);
    },
    getReducers: function(env) {
        return reducer(env);
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/index.js